import { Link, useNavigate } from "react-router-dom";
import logo from "../images/Mascot-logo.png";
import { ArrowLeft } from "lucide-react";

export default function SimpleNavigation() {
  const navigate = useNavigate();

  return (
    <nav className="bg-primary shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <img src={logo} alt="Bookshelf" className="h-10 w-10" />
          <a href="/" className="text-2xl font-bold text-gray-900">
            Bookshelf
          </a>
        </div>

        <div className="flex ml-auto gap-3 justify-end align-center items-center">
          <ArrowLeft size={18} strokeWidth={1.5} className="text-gray-600" />
          <Link
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            } }
            className="text-gray-600 hover:text-gray-900 transition font-semibold cursor-pointer" to={""}          >
            Go Back
          </Link>
        </div>
      </div>
    </nav>
  );
}
